const isDevelopmentEnv = process.env.NODE_ENV === "development";
const isProductionEnv = process.env.NODE_ENV === "production";
const isTestEnv = process.env.NODE_ENV === "test";

export { isDevelopmentEnv, isProductionEnv, isTestEnv };
